import { styled } from '@mui/material/styles';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Link as RouterLink, Outlet } from 'react-router-dom';

// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
    top: 0,
    left: 0,
    lineHeight: 0,
    width: '100%',
    position: 'absolute',
    padding: theme.spacing(3, 3, 0),
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(5, 5, 0),
    },
}));

// ----------------------------------------------------------------------

export default function LogoOnlyLayout(): JSX.Element {
    const theme = useTheme();
    return (
        <>
            <HeaderStyle>
                <RouterLink to="/">
                    {theme.palette.mode === 'light' ? (
                        <img
                            alt="WeTranslate"
                            src={`/static/icons/logo_text_dark.svg`}
                            style={{ maxWidth: '300px', maxHeight: '30px' }}
                        />
                    ) : (
                        <img
                            alt="WeTranslate"
                            src={`/static/icons/logo_text_light.svg`}
                            style={{ maxWidth: '300px', maxHeight: '30px' }}
                        />
                    )}
                </RouterLink>
            </HeaderStyle>
            <Outlet />
        </>
    );
}
